import React, { useState } from "react";

// Function to parse time string into an object
const parseTimeString = (timeString) => {
  if (!timeString) {
    return { hour: "12", minute: "00", period: "AM" };
  }
  const regex = /(\d{1,2}):(\d{2})\s([APM]{2})/;
  const match = timeString.match(regex);

  if (match) {
    const hour = match[1];
    const minute = match[2];
    const period = match[3];

    return { hour, minute, period }; // Return an object with hour, minute, and period
  }

  return { hour: "12", minute: "00", period: "AM" }; // Default if invalid format
};

const TimeInput = ({
  label,
  value,
  onChange,
  name,
  required = false,
  error,
  className,
}) => {
  const [time, setTime] = useState(
    parseTimeString(value) || { hour: "12", minute: "00", period: "AM" }
  );

  const handleChange = (field, newValue) => {
    const updatedTime = { ...time, [field]: newValue };
    setTime(updatedTime);
    if (onChange) {
      onChange(
        name,
        `${updatedTime.hour}:${updatedTime.minute} ${updatedTime.period}`
      );
    }
  };

  return (
    <div className={`flex flex-col ${className}`}>
      {label && (
        <label className="text-gray-700 mb-2 font-regular flex items-center text-sm">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="flex space-x-2">
        {/* Hours */}
        <select
          className="border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          value={time.hour}
          onChange={(e) => handleChange("hour", e.target.value)}
        >
          {[...Array(12).keys()].map((h) => (
            <option key={h + 1} value={String(h + 1).padStart(2, "0")}>
              {String(h + 1).padStart(2, "0")}
            </option>
          ))}
        </select>

        {/* Minutes */}
        <select
          className="border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          value={time.minute}
          onChange={(e) => handleChange("minute", e.target.value)}
        >
          {["00", "15", "30", "45"].map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>

        {/* AM/PM */}
        <select
          className="border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          value={time.period}
          onChange={(e) => handleChange("period", e.target.value)}
        >
          <option value="AM">AM</option>
          <option value="PM">PM</option>
        </select>
      </div>

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default TimeInput;
